import { createSlice } from '@reduxjs/toolkit';
import { UserState } from './types';
import { T_getUserInfo, T_getJoyrideStatus } from './thunk';


const initialState: UserState = {
  isSignedIn: 'pending',
  id: '',
  name: '',
  firstName: '',
  lastName: '',
  userName: '',
  licenseType: 0,
  licenseInfo: {
    viewDatabase: false,
    ccsModule: false,
    viewAnalogue: false,
    validFrom:'',
    validTo:'',
    id:'',
    clientAdminEmail: ''
  },
  joyrideStatus: {}
};

export const userStateSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserStatus: (state, { payload }) => {
        state.isSignedIn = payload
    },
    setJoyrideStatus: (state, { payload }) => {
        state.joyrideStatus = payload
    },
    updateJoyrideTourStatus: (state, { payload }: { payload: { tourKey: string, completed: boolean } }) => {
        state.joyrideStatus[payload.tourKey] = payload.completed
    }
  },
  extraReducers: {
    [T_getUserInfo.pending.type]: (state) => {
      state.isSignedIn = 'pending';
      state.id = '';
      state.name = '';
      state.firstName = '';
      state.lastName = '';
      state.userName = '';
    },
    [T_getUserInfo.fulfilled.type]: (state, action) => {
      state.isSignedIn = true;
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.userName = action.payload.userName;
      state.licenseType = action.payload?.licenseInfo?.licenseType
      state.licenseInfo = action.payload.licenseInfo;
      state.joyrideStatus = action.payload.joyrideStatus || {};
      
    },
    [T_getUserInfo.rejected.type]: (state) => {
      state.isSignedIn = false
    },
    [T_getJoyrideStatus.fulfilled.type]: (state, action) => {
      state.joyrideStatus = action.payload;
    }
  },
})

export default userStateSlice.reducer